import { render, staticRenderFns } from "./ModalInsertCoupon.vue?vue&type=template&id=520462d4&"
import script from "./ModalInsertCoupon.vue?vue&type=script&lang=js&"
export * from "./ModalInsertCoupon.vue?vue&type=script&lang=js&"
import style0 from "./ModalInsertCoupon.vue?vue&type=style&index=0&id=520462d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports